import React from 'react';
import { Button, Card, Divider, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, DollarOutlined, ExportOutlined } from '@ant-design/icons';
import { textNumberFormater } from '../../../../utils';
import { renderDeliveryStatusTag, renderPaymentStatusTag } from './billDetailHelpers';

const { Text } = Typography;

interface BillDetailGeneralStatusCardProps {
  isSettled: boolean;
  deliveryStatus: string;
  hasPendingFulfillment: boolean;
  onGoToStorageDispatch: () => void;
  totalDoc: number;
  totalPaid: number;
  balanceDue: number;
  paymentStatus: string;
  onOpenPaymentModal: () => void;
}

export const BillDetailGeneralStatusCard: React.FC<BillDetailGeneralStatusCardProps> = ({
  isSettled,
  deliveryStatus,
  hasPendingFulfillment,
  onGoToStorageDispatch,
  totalDoc,
  totalPaid,
  balanceDue,
  paymentStatus,
  onOpenPaymentModal
}) => {
  return (
    <Card 
      title={
        <Space>
          <DollarOutlined style={{ color: "#52c41a" }} />
          <span>Estado General y Cartera</span>
        </Space>
      } 
      className="card-shadow" 
      style={{ marginBottom: 16, borderTop: isSettled ? '3px solid #52c41a' : '3px solid #1890ff' }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ marginBottom: 4 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>Liquidación Integral:</Text>
          <div style={{ marginTop: 4 }}>
            {isSettled ? (
              <Tag color="success" icon={<CheckCircleOutlined />} style={{ width: '100%', textAlign: 'center', padding: '4px 0', fontSize: 12, fontWeight: 600 }}>
                100% LIQUIDADA (ENTREGA Y PAGO)
              </Tag>
            ) : (
              <Tag color="processing" icon={<ClockCircleOutlined />} style={{ width: '100%', textAlign: 'center', padding: '4px 0', fontSize: 12 }}>
                CICLO PENDIENTE POR COMPLETAR
              </Tag>
            )}
          </div>
        </div>

        <div style={{ marginBottom: 4 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>Despacho / Entrega Física:</Text>
          <div style={{ marginTop: 4 }}>
            {renderDeliveryStatusTag(deliveryStatus)}
          </div>
          {hasPendingFulfillment && (
            <Button
              type="default"
              block
              icon={<ExportOutlined />}
              style={{ marginTop: 8 }}
              onClick={onGoToStorageDispatch}
            >
              Gestionar Despacho en Almacén
            </Button>
          )}
        </div>

        <Divider style={{ margin: '8px 0' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text type="secondary">Total Facturado:</Text>
          <Text strong>{textNumberFormater(totalDoc)}</Text>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text type="secondary">Total Abonado / Pagado:</Text>
          <Text strong style={{ color: '#52c41a' }}>{textNumberFormater(totalPaid)}</Text>
        </div>
        <Divider style={{ margin: '6px 0' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Text strong>Saldo Pendiente:</Text>
          <Text strong style={{ fontSize: 16, color: balanceDue > 0 ? '#f5222d' : '#52c41a' }}>
            {textNumberFormater(balanceDue)}
          </Text>
        </div>
        <div style={{ marginTop: 4 }}>
          {renderPaymentStatusTag(paymentStatus)}
        </div>
        {balanceDue > 0 && (
          <Button
            type="primary"
            block
            icon={<DollarOutlined />}
            style={{ marginTop: 8, backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            onClick={onOpenPaymentModal}
          >
            Registrar Abono
          </Button>
        )}
      </Space>
    </Card>
  );
};
